// extracted by mini-css-extract-plugin
export default {"outer-container":"heNRyc_5ZxU0m7WSpTG0","outerContainer":"heNRyc_5ZxU0m7WSpTG0","inner-container":"KTriR0xP5MEwG7juH2Ui","innerContainer":"KTriR0xP5MEwG7juH2Ui"};